import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedLanguage: 1, // Default language ID
};

const quranSlice = createSlice({
  name: "quran",
  initialState,
  reducers: {
    setSelectedLanguage: (state, action) => {
      state.selectedLanguage = action.payload;
    },
  },
});

export const { setSelectedLanguage } = quranSlice.actions;

export default quranSlice.reducer;
